/**
 * MIME type (or extension token) → short display label for file-input hints.
 * `null` skips the type in the accept label (internal / non-user-facing).
 */
export const MIME_TYPE_LABELS: ReadonlyMap<string, string | null> = new Map([
  ['application/pdf', 'PDF'],
  ['application/msword', 'DOC'],
  ['application/doc', 'DOC'],
  ['application/docx', 'DOCX'],
  [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'DOCX',
  ],
  [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'XLSX',
  ],
  ['application/vnd.oasis.opendocument.text', 'ODT'],
  ['application/x-empty', null],
  ['text/csv', 'CSV'],
  ['.csv', 'CSV'],
  ['image/jpeg', 'JPEG'],
  ['image/jpg', 'JPEG'],
  ['image/png', 'PNG'],
  ['image/webp', 'WEBP'],
  ['image/heic', 'HEIC'],
  ['image/tiff', 'TIFF'],
  ['image/gif', 'GIF'],
  ['image/svg+xml', 'SVG'],
  ['image/bmp', 'BMP'],
]);
